import {history} from "prosemirror-history";
import {selectionTrackingPlugin} from "../selectionTrackingPlugin";
import {snippetDropPlugin} from "../snippetDropPlugin";
import {createImageUploadPlugin} from "../imageUploadPlugin";
import {authorHighlightPlugin} from "../authorHighlightPlugin";

export function createOptionalPluginBundle({
                                               collaborationEnabled,
                                               yXmlFragment,
                                               onSelectionChange,
                                               snippetDrop,
                                               provider,
                                               user,
                                           }) {
    const plugins = [];

    // Author highlight — off by default; toggled via the "Show Authors" toolbar button.
    plugins.push(authorHighlightPlugin({enabled: false}));

    if (!(collaborationEnabled && yXmlFragment)) {
        plugins.push(history());
    }

    if (onSelectionChange) {
        plugins.push(selectionTrackingPlugin(onSelectionChange));
    }

    if (snippetDrop) {
        plugins.push(snippetDropPlugin(snippetDrop));
    }

    if (provider) {
        // Image upload plugin handles paste / drop of image files.
        // Resize handles and figure rendering are done by FigureNodeView.
        plugins.push(createImageUploadPlugin(provider));
    }

    return plugins;
}

